const getFiltersNames = (filters, dietaryRequirementsData) =>
  filters.map(
    (filter) => dietaryRequirementsData.find(({ requirementId }) => requirementId === filter).name,
  );

export default getFiltersNames;
